import { createContext, useEffect, useState } from "react";

export const UserContext = createContext({
  login: (data) => {},
  isAuthenticated: false,
  token: null,
  logout: () => {},
  loading: true,
  toggleMenuFlag: false,
  handleMenu: () => {}
});

const AuthContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [toggleMenuFlag, setToggleMenuFlag] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getToken = localStorage.getItem("token");
    if (!getToken) {
      setLoading(false);
      return;
    }
  
    try {
      const payload = JSON.parse(atob(getToken.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();
      console.log('token expired', isExpired);
      if (isExpired) {
        logout();
      } else {
        setToken(getToken);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Invalid token", error);
      logout();
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (token) => {
    localStorage.setItem("token", token);
    setToken(token);
    setIsAuthenticated(true);
  };
  const logout = () => {
    setToken(null);
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };
  const handleMenu = ()=> {
    console.log("is authenticated", isAuthenticated)
    setToggleMenuFlag(!toggleMenuFlag)
  }
  return (
    <UserContext.Provider
      value={{ loading, isAuthenticated, token, login, logout, toggleMenuFlag, handleMenu }}
    >
      {children}
    </UserContext.Provider>
  );
};
export default AuthContextProvider;
